function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "#fff",
  stroke: "#3A3544",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 6,
  fill: "#3A3544"
});

function SvgRadioChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgRadioChecked;